/**
 * Footer component.
 * @module components/theme/Footer/Footer
 */

import React from 'react';
import {
  Container,
  List,
  Segment,
  Grid,
  //GridRow,
  GridColumn,
  //Icon,
  //Button,
  //ButtonContent,
} from 'semantic-ui-react';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { UniversalLink } from '@plone/volto/components';

import { useGoogleAnalytics } from 'volto-google-analytics';
const messages = defineMessages({
  copyright: {
    id: 'Copyright',
    defaultMessage: 'Copyright',
  },
});

/**
 * Component to display the footer.
 * @function Footer
 * @param {Object} intl Intl object
 * @returns {string} Markup of the component
 */
const Footer = ({ intl }) => {
  useGoogleAnalytics();
  return (
    <div class="footer-container print_hide">
      <Segment
        role="contentinfo"
        vertical
        padded
        inverted
        id="footer"
        aria-label="Footer"
      >
        <div>
          <div id="footer-main">
            <Grid padded stackable>
              <GridColumn width={2} textAlign="left" className="columnborder">
                <List>
                  <List.Header>
                    <h4>About</h4>
                  </List.Header>
                  <List.Content>
                    <List.Item>
                      <UniversalLink href="/services">What we do</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/pricing">Pricing</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/team">The team</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/portfolio">Our work</UniversalLink>
                    </List.Item>
                  </List.Content>
                </List>
              </GridColumn>
              <GridColumn width={2} textAlign="left" className="columnborder">
                <List>
                  <List.Header>
                    <h4>Media</h4>
                  </List.Header>
                  <List.Content>
                    <List.Item>
                      <UniversalLink href="/news">News</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/videos">Videos</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/subscribe-to-our-mailer">Subscribe to our mailer</UniversalLink>
                    </List.Item>
                  </List.Content>
                </List>
              </GridColumn>
              <GridColumn width={2} textAlign="left" className="columnborder">
                <List>
                  <List.Header>
                    <h4>Quick links</h4>
                  </List.Header>
                  <List.Content>
                    <List.Item>
                      <UniversalLink href="/privacy-policy">Privacy policy</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/terms-and-conditions">Terms of use</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink target="_blank" href="/paia_section_51_manual_juizi.pdf/@@download/file">PAIA Manual</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink href="/contact-us">Contact us</UniversalLink>
                    </List.Item>
                    <List.Item>
                      <UniversalLink className="hero-button white-outline" href="/discovery-session">Book a discovery session</UniversalLink>
                    </List.Item>
                  </List.Content>
                </List>
              </GridColumn>
              <GridColumn width={6} textAlign="right" verticalAlign="bottom">
                <List>
                  <List.Content>
                    <List.Item className="footer-sitesocial">
                      <List horizontal>
                        <List.Item>
                          <UniversalLink
                            href="https://www.linkedin.com/company/juizi-cc"
                            target="_blank" title="LinkedIn"
                          >
                            <i class="bi bi-linkedin"></i>
                          </UniversalLink>
                        </List.Item>
                        <List.Item>
                          <UniversalLink
                            href="https://www.facebook.com/juizi.web"
                            target="_blank" title="Facebook"
                          >
                            <i class="bi bi-facebook"></i>
                          </UniversalLink>
                        </List.Item>
                        <List.Item>
                          <UniversalLink
                            href="https://bsky.app/profile/juizi-web.bsky.social"
                            target="_blank" title="Bluesky"
                          >
                            <i class="bi bi-bluesky"></i>
                          </UniversalLink>
                        </List.Item>
                        <List.Item>
                          <UniversalLink
                            href="https://www.youtube.com/@juiziweb"
                            target="_blank" title="YouTube"
                          >
                            <i class="bi bi-youtube"></i>
                          </UniversalLink>
                        </List.Item>
                        <List.Item>
                          <UniversalLink
                            href="https://plone.social/@Juizi@mastodon.social"
                            target="_blank" title="Mastodon"
                          >
                            <i class="bi bi-mastodon"></i>
                          </UniversalLink>
                        </List.Item>
                        <List.Item>
                          <UniversalLink
                            href="https://x.com/juizi_web"
                            target="_blank" title="X"
                          >
                            <i class="bi bi-twitter-x"></i>
                          </UniversalLink>
                        </List.Item>
                      </List>
                    </List.Item>
                    <List.Item className="footer-siteattr">
                      <FormattedMessage
                        id="{copyright} Juizi {current_year}"
                        defaultMessage="{copyright} Juizi {current_year}"
                        values={{
                          copyright: (
                            <abbr
                              title={intl.formatMessage(messages.copyright)}
                            >
                              ©
                            </abbr>
                          ),
                          current_year: new Date().getFullYear(),
                        }}
                      />
                    </List.Item>
                    <List.Item className="footer-siteattr">
                      Stock images/videos courtesy of <a href="https://www.pexels.com" target="_blank">Pexels</a> & <a href="https://unsplash.com" target="_blank">Unsplash</a>
                    </List.Item>
                    <List.Item>
                      <UniversalLink
                        href="#top"
                        class="header-link"
                        title="Back to top"
                      >
                        <i class="bi bi-arrow-up-square"></i>
                      </UniversalLink>
                    </List.Item>
                  </List.Content>
                </List>
              </GridColumn>
            </Grid>
          </div>
        </div>
      </Segment>
      <div class="belowFooter">
        <a href="https://juizi.com" target="_blank">
          <img src="https://juizi.com/juizi.png" />
        </a>
      </div>
    </div>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
Footer.propTypes = {
  /**
   * i18n object
   */
};

export default injectIntl(Footer);
